import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBSioSAyScnxy1_qvFAYIhmf1YhuUN8VLM",
  authDomain: "wiin-58368.firebaseapp.com",
  projectId: "wiin-58368",
  storageBucket: "wiin-58368.firebasestorage.app",
  messagingSenderId: "872244776650",
  appId: "1:872244776650:web:0dd8a610766ac3370fae33"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db }; 